import { render, staticRenderFns } from "./CountersCard.vue?vue&type=template&id=09480ab9&"
import script from "./CountersCard.vue?vue&type=script&lang=js&"
export * from "./CountersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports